import React from 'react'
import {IconProps, IconWrapper} from './IconWrapper'

const renderIcon = (color: string) => (
    <path
        d="M9 5.25V9H12.75M9 15.75C5.27208 15.75 2.25 12.7279 2.25 9C2.25 5.27208 5.27208 2.25 9 2.25C12.7279 2.25 15.75 5.27208 15.75 9C15.75 12.7279 12.7279 15.75 9 15.75Z"
        stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
)

export const Clock: React.FC<IconProps> = ({color, size}) =>
    <IconWrapper {...{size, color, renderIcon}} viewBox={`0 0 18 18`}/>
